export default __webpack_public_path__ + "static/media/pdfView.152b9440.svg";